import React from 'react';
import PropTypes from 'prop-types';


const SelectFilterPropTypes = {
  selected: PropTypes.oneOfType([
    PropTypes.bool,
    PropTypes.string,
  ]).isRequired,
  filter: PropTypes.object.isRequired,
  updateFilterBy: PropTypes.func.isRequired,
};

/* SelectFilter
 * Simple select input for filtering the table data by one of multiple options
 */
const SelectFilter = ({
  updateFilterBy,
  filter: {
    prop,
    name,
    options,
  },
  selected,
}) => {
  const handleFilterByChange = event => {
    updateFilterBy(prop, event.target.value);
  };

  return (
    <div>
      {name ? (
        <label htmlFor={name}>{name}: </label>
      ) : false }

      <select
        value={selected}
        onChange={handleFilterByChange}
      >
        {options.map(option => (
          <option key={option[0]} value={option[0]}>{option[1]}</option>
        ))}
      </select>
    </div>
  );
};
SelectFilter.propTypes = SelectFilterPropTypes;

export default SelectFilter;
